import styles from './blocks.module.css';

/**
 * Compact scope reminder for the block editor sheet.
 */
export default function CaseScopeBanner({
    protocolName,
    hasProtocol = false,
    compact = false,
}) {
    const text = hasProtocol && protocolName
        ? `From ${protocolName} · edits stay on this case`
        : 'Edits stay on this case';

    return (
        <div
            className={compact ? styles.caseScopeBannerCompact : styles.caseScopeBanner}
            role="status"
        >
            {text}
        </div>
    );
}
